'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './publicDocumentation.routes';
import {$, jQuery} from 'jquery';
import _ from "lodash";

export class PublicDocumentationComponent {
  constructor($state, $scope, publicDocConfig) {
    $scope.$state = $state;
    $scope.settings = {};

    $scope.items = [
      {
        title: 'Public General Information',
        items: publicDocConfig.publicDocumentation.map(x => {
          return {
            name: x.title,
            state: `publicDocumentation.${x.name}`,
            items: x.items,
            version: x.version,
            id: x.id,
            space: x.space,            
          };
        })
      }
    ];

    $scope.selectedMenu = {};

    $scope.navigateToState = item => {
      $scope.selectedMenu = item;
      $state.transitionTo(item.state);
    };

    $scope.navigateToSubItem = ($event, subItem) => {
      $event.preventDefault();
      window.jQuery([document.documentElement, document.body]).animate({
          scrollTop: window.jQuery(`#${subItem.id}`).offset().top - 75
      }, 1000);
    };

    $scope.getCurrentMenu = () => {
      let result = {};
      _.forEach($scope.items, i => {
        const state = _.find(i.items, s => s.state === $state.current.name);
        if(state)
          result = state;
      });
      return result;
    };

    $scope.$on('$viewContentLoaded', function(){
      $scope.selectedMenu = $scope.getCurrentMenu();
      window.confluenceInfo = $scope.selectedMenu;
    });
  }
}

PublicDocumentationComponent.$inject = ['$state', '$scope', 'publicDocConfig'];

export default angular.module('syncplicityLoginApp.publicDocumentation', [uiRouter])
  .config(routes)
  .component('publicdocumentation', {
    template: require('../static/documentation.html'),
    controller: PublicDocumentationComponent,
    controllerAs: 'publicDocumentationCtrl'
  })
  .name; 



// WEBPACK FOOTER //
// ./client/app/documentation/public/publicDocumentation.component.js